/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import r from"../portal/Portal.js";function l(l,t){if(null===l)return t;return new r({url:l.field("url")})}export{l as getPortal};
